import React from "react";
import { components, GroupBase, OptionProps } from "react-select";
import { MenuItem } from "../../../../../../components/@types";
import ClassificationIcon from "../../../../../../components/ClassificationIcon";

const { Option } = components;

function CustomOption<
  OptionType extends MenuItem,
  IsMulti extends boolean = false,
  Group extends GroupBase<OptionType> = GroupBase<OptionType>
>(props: OptionProps<OptionType, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};
  const { label, value } = props.data;
  return (
    <span data-testid={`${testIdKey}_field_option_${value || label}`}>
      <Option {...props}>{props.children}</Option>
    </span>
  );
}

function CustomClassificationOption<
  OptionType extends MenuItem,
  IsMulti extends boolean = false,
  Group extends GroupBase<OptionType> = GroupBase<OptionType>
>(props: OptionProps<OptionType, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};
  const { label, value } = props.data;
  return (
    <span data-testid={`${testIdKey}_field_option_${value || label}`}>
      <Option {...props}>
        <ClassificationIcon classification={value} />
        {label}
      </Option>
    </span>
  );
}

export { CustomOption, CustomClassificationOption };
